import { graphql } from 'gatsby';

import {
  StageVideo,
  StageVideoProps,
} from '../../../components/strapi/stage-video';
import { PossibleStageComponents } from './stage-section';

export const StageVideoFragment = graphql`
  fragment StageVideoFragment on STRAPI__COMPONENT_SHARED_STAGE_VIDEO {
    strapi_component
    headline
    subline
    video {
      ...ResponsiveVideoFragment
    }
  }
`;

export const componentName = 'shared.stage-video';

export type StageVideoData = StageVideoProps & {
  strapi_component: typeof componentName;
};

export const isStageVideo = (
  component: PossibleStageComponents,
): component is StageVideoData => {
  return component.strapi_component === componentName;
};

export const StrapiStageVideo = StageVideo;
